/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// custom typefaces
require("@fontsource/montserrat/latin-400.css")
require("@fontsource/montserrat/latin-500.css")
require("@fontsource/montserrat/latin-600.css")
require("@fontsource/montserrat/latin-700.css")
require("@fontsource/montserrat/latin-800.css")
require("@fontsource/open-sans/latin-400.css")
require("@fontsource/open-sans/latin-500.css")
require("@fontsource/open-sans/latin-400-italic.css")
require("@fontsource/open-sans/latin-700.css")

const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  // if the new route is part of the list above, scroll to top (0, 0)
  if (!location.hash) {
    window.scrollTo(0, 0)
  } else {
    const currentPosition = getSavedScrollPosition(location)
    window.scrollTo(...(currentPosition || [0, 0]))
  }

  return false
}

const onRouteUpdate = ({ location }) => scrollToAnchor(location)

/**
 *
 * @desc - a function to jump to the correct scroll position
 * @param {Object} location -
 * @param {Number} [mainNavHeight] - the height of any persistent nav -> document.querySelector(`nav`)
 */
function scrollToAnchor(location, mainNavHeight = 88) {
  // Check for location so build does not fail
  if (location && location.hash) {
    const target = document.getElementById(
      decodeURIComponent(location.hash.slice(1))
    )
    if (target) {
      const reduceMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches
      window.scrollTo({
        top: target.offsetTop - mainNavHeight,
        behavior: reduceMotion ? "auto" : "smooth"
      })
    }
  }

  return true
}

export { shouldUpdateScroll, onRouteUpdate }
